import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { JacHome } from './types';

export function useJacHomeData(): Page<JacHome>['templateFields'] {
  return useCurrentPage<Page<JacHome>>().templateFields;
}
